import { StateNode, TLStateNodeConstructor } from "tldraw"
import { Idle } from "./Idle"
import { Pointing } from "./Pointing"
import { IdleFill } from "./IdleFill"

/** @public */
export class LDGeoShapeTool extends StateNode {
  static override id = "custom-geo"
  static override initial = "idle"
  static override children(): TLStateNodeConstructor[] {
    return [IdleFill, Idle, Pointing]
  }
  override shapeType = "custom-geo"
}
